export default {"name":"NovaComponents-MessageToast-gui-icu","NovaComponents-MessageToast-gui-icu.close.icon.tooltip.label":"Close the toast"}